import { useNavigate } from "react-router-dom";
import { Button } from "../../../../../components/buttons/button";
import { ContainerCard } from "../../../../../components/cards/containerCard";
import { InformationCardNoIcon } from "../../../../../components/cards/infoCard";
import { TextInputViewOnly } from "../../../../../components/inputs/textInputViewOnly";
import { ProfilePicture } from "../../../../../components/profile/profilePicture";
import { formatDate } from "../../../../../helperFunctions";
import { useAppSelector } from "../../../../../redux/hooks";

export const MemberProfileView = () => {
  const { profile } = useAppSelector((state) => state.auth);

  const navigate = useNavigate();

  const goToProfileEdit = () => {
    navigate("/app/settings/profile/edit");
  };

  return (
    <div className="w-full flex flex-row flex-wrap gap-2 md:gap-6">
      {/* Main information half */}
      <div className="w-full md:max-w-[500px] order-last md:order-first">
        <InformationCardNoIcon
          className="mb-2 md:mb-4"
          info={
            <div>
              Click the{" "}
              <span className="text-pry-green-200 font-medium">Edit</span>{" "}
              button update your profile
            </div>
          }
        />

        <ContainerCard className="flex flex-col gap-7">
          {/* Title and button */}
          <div className="w-full flex flex-row gap-4 items-center justify-between">
            <h1 className="font-bold text-base">Profile</h1>

            <Button
              text="Edit"
              onClick={() => goToProfileEdit()}
              type="button"
              className="!min-w-[82px] md:!min-w-[107px] !w-fit"
              size="medium"
              loading={false}
              disabled={false}
              variation="primary"
            />
          </div>

          {/* Profile details */}
          <div className="flex flex-col gap-2">
            <TextInputViewOnly
              className=""
              text="First Name"
              subtext={profile?.FirstName}
              hasIcon={!profile?.FirstName}
              extraContent={undefined}
            />

            <TextInputViewOnly
              className=""
              text="Last Name"
              subtext={profile?.LastName}
              hasIcon={!profile?.LastName}
              extraContent={undefined}
            />

            <TextInputViewOnly
              className=""
              text="Middle Name"
              subtext={
                profile?.MiddleName?.replaceAll("#", "") || "Not specified"
              }
              hasIcon={!profile?.MiddleName?.replaceAll("#", "")}
              extraContent={undefined}
            />

            <TextInputViewOnly
              className=""
              text="Date of Birth"
              subtext={
                profile?.DateOfBirth
                  ? formatDate(profile?.DateOfBirth)
                  : "Not specified"
              }
              hasIcon={!profile?.DateOfBirth}
              extraContent={undefined}
            />

            <TextInputViewOnly
              className=""
              text="Phone Number"
              subtext={
                profile?.PhoneNumber?.replaceAll("#", "")
                  ? `+${
                      profile?.PhoneNumberCode
                    }${profile?.PhoneNumber?.replaceAll("#", "")}`
                  : "Not specified"
              }
              hasIcon={!profile?.PhoneNumber?.replaceAll("#", "")}
              extraContent={undefined}
            />

            <TextInputViewOnly
              className=""
              text="Email Address"
              subtext={profile?.Email}
              hasIcon={false}
            />

            <TextInputViewOnly
              className=""
              text="Residential Address"
              subtext={profile?.Address || "Not specified"}
              hasIcon={!profile?.Address}
              extraContent={undefined}
            />

            <TextInputViewOnly
              className=""
              text="Country"
              subtext={profile?.Country?.replaceAll("#", "") || "Not specified"}
              hasIcon={!profile?.Country?.replaceAll("#", "")}
              extraContent={undefined}
            />

            <TextInputViewOnly
              className=""
              text="State"
              subtext={profile?.State?.replaceAll("#", "") || "Not specified"}
              hasIcon={!profile?.State?.replaceAll("#", "")}
              extraContent={undefined}
            />

            <TextInputViewOnly
              className=""
              text="Date Joined"
              subtext={formatDate(profile?.DateAdded)}
              hasIcon={false}
            />
          </div>
        </ContainerCard>
      </div>

      {/* Logo half */}

      <ContainerCard
        className="
            flex flex-1 flex-col items-center justify-center
            gap-6 md:sticky-top !h-fit
          "
      >
        <div className="w-full max-w-[353px] text-center">
          <p className="font-bold text-base">Profile Picture</p>

          <p className="mt-1 text-pry-dark-green-300/60">
            Your picture will be visible to your cooperatives on ThriftCorp
          </p>
        </div>

        <ProfilePicture className="!w-[106px] !h-[106px] !text-2xl !font-bold" />

        <Button
          text={!!profile?.Picture ? "Change photo" : "Add a photo"}
          onClick={() => {
            goToProfileEdit();
          }}
          type="button"
          className="!min-w-[80px] !max-w-fit"
          size="small"
          loading={false}
          disabled={false}
          variation="secondary-light"
        />
      </ContainerCard>
    </div>
  );
};
